import React, { FC, useContext } from 'react'
import { Trans, t } from '@lingui/macro'
import BorderedBox from '../../../../components/common/bordered-box/BorderedBox'
import Tag from '../../../../components/common/tag/Tag'
import classNames from 'classnames'
import {
  ICampaignActionItemListProps,
  ManageCampaignContext
} from '../../ManageCampaignPage'

import Loader from '../../../../components/common/loader/Loader'

import { useQueryParam, ArrayParam } from 'use-query-params'
import {
  useGetPathwaysForCampaignShareActionQuery,
  useGetPathwaysByIdsQuery
} from './CampaignPathwayShareList.codegen'

export const CampaignPathwayShareList: FC<ICampaignActionItemListProps> = ({
  actionId
}) => {
  const { campaign } = useContext(ManageCampaignContext)

  const { data, loading } = useGetPathwaysForCampaignShareActionQuery({
    variables: { campaignId: campaign.id, actionId }
  })
  if (loading) {
    return <Loader />
  }
  const actionPathways =
    data?.admin?.campaign?.pathwayShareAction?.actionPathways
  if (actionPathways) {
    return (
      <>
        <h3>
          {`${actionPathways.length} `}
          {actionPathways.length === 1 ? t`Pathway` : t`Pathways`}{' '}
          <Trans>Selected</Trans>
        </h3>
        {actionPathways.map((actionPathway) => {
          const { pathway } = actionPathway
          return (
            <BorderedBox
              key={pathway.id}
              className={classNames('List__Row', {
                [`List__Row--deleted`]: pathway.deleted_at
              })}
            >
              <strong>{pathway.title}</strong>
              <span>
                {pathway.deleted_at && (
                  <Tag color="redOpen" size="small">
                    <Trans>Deleted</Trans>
                  </Tag>
                )}
                {!pathway.published_date && (
                  <Tag color="redOpen" size="small">
                    <Trans>Unpublished</Trans>
                  </Tag>
                )}
              </span>
            </BorderedBox>
          )
        })}
      </>
    )
  }
  return null
}

export const CampaignNewPathwayShareList: FC = () => {
  const [selectedIds] = useQueryParam('selectedIds', ArrayParam)

  const { data } = useGetPathwaysByIdsQuery({
    variables: {
      ids:
        selectedIds?.map((id) => {
          return Number(id)
        }) ?? []
    }
  })
  const pathways = data?.admin?.organisation?.pathways
  if (!pathways) {
    return null
  }

  return (
    <>
      <h3>
        {`${pathways.length} `}
        {pathways.length === 1 ? t`Pathway` : t`Pathways`}{' '}
        <Trans>Selected</Trans>
      </h3>
      {pathways.map((pathway) => {
        return (
          <BorderedBox
            key={pathway.id}
            className={classNames('List__Row', {
              [`List__Row--deleted`]: pathway.deleted_at
            })}
          >
            <strong>{pathway.title}</strong>
            <span>
              {pathway.deleted_at && (
                <Tag color="redOpen" size="small">
                  <Trans>Deleted</Trans>
                </Tag>
              )}
              {!pathway.published_date && (
                <Tag color="redOpen" size="small">
                  <Trans>Unpublished</Trans>
                </Tag>
              )}
            </span>
          </BorderedBox>
        )
      })}
    </>
  )
}
